import { render, staticRenderFns } from "./SpaceManagerBanner.vue?vue&type=template&id=55a7fa2d&scoped=true"
import script from "./SpaceManagerBanner.vue?vue&type=script&lang=js"
export * from "./SpaceManagerBanner.vue?vue&type=script&lang=js"
import style0 from "./SpaceManagerBanner.vue?vue&type=style&index=0&id=55a7fa2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a7fa2d",
  null
  
)

export default component.exports